import React, { useState, useEffect } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import "./Rightpart.css";
import ordersdetail from "../assets/images/order-detail.png";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocalPhoneOutlinedIcon from "@mui/icons-material/LocalPhoneOutlined";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { fetchAPI, fetchUserAppAPI } from "../../utils/api";
import { ShimmerTable } from "react-shimmer-effects";

const renderAddress = (order) => {
  if (!order) return "Primary Address";

  const addrObj = order.address && typeof order.address === "object" ? order.address : null;

  const plotNo = addrObj ? (addrObj.plot_no || addrObj.address_plot_no) : order.address_plot_no;
  const locality = addrObj ? (addrObj.locality || addrObj.locility || addrObj.address_locility) : order.address_locility;
  const area = addrObj ? (addrObj.area || addrObj.address_area) : order.address_area;
  const city = addrObj ? (addrObj.city || addrObj.city_name || addrObj.address_city) : (order.city_name || order.address_city);
  const state = addrObj ? (addrObj.state || addrObj.state_name || addrObj.address_state) : (order.state_name || order.address_state);
  const pincode = addrObj ? (addrObj.pincode || addrObj.address_pincode) : order.address_pincode;

  const parts = [plotNo, locality, area, city, state].filter(Boolean);
  if (parts.length > 0) {
    return `${parts.join(", ")}${pincode ? ` - ${pincode}` : ""}`;
  }

  const addrId = order.order_address_id || order.address_id || (addrObj ? addrObj.id : null);
  return addrId ? `Address ID #${addrId}` : "Primary Address";
};

export default function OrderdetailRight() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [user, setUser] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  const selectedOrderId = searchParams.get("id");

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (!storedUser) {
      navigate("/login");
      return;
    }
    const parsedUser = JSON.parse(storedUser);
    setUser(parsedUser);

    const fetchOrders = async () => {
      try {
        setLoading(true);
        let allOrders = [];

        // 1. Fetch equipment orders
        try {
          const res1 = await fetchUserAppAPI("equipments-list-order", {
            method: "POST",
            body: JSON.stringify({ user_id: parsedUser.user_id }),
          });
          if (res1 && res1.status === 200 && Array.isArray(res1.result)) {
            allOrders = [
              ...allOrders,
              ...res1.result.map((o) => ({ ...o, _type: "product" })),
            ];
          }
        } catch (e) {}

        // 2. Fetch service bookings
        try {
          let res2 = null;
          try {
            res2 = await fetchAPI("CaregiverController/order_list", {
              method: "POST",
              body: JSON.stringify({ user_id: parsedUser.user_id }),
            });
          } catch (e) {
            res2 = await fetchUserAppAPI("services-order-list", {
              method: "POST",
              body: JSON.stringify({ user_id: parsedUser.user_id }),
            });
          }
          if (res2 && res2.status === 200 && Array.isArray(res2.result)) {
            const formattedServices = res2.result.map((s) => {
              const firstItem =
                s.items && s.items.length > 0 ? s.items[0] : null;
              const serviceTitle = firstItem
                ? firstItem.service?.title ||
                  firstItem.package?.title ||
                  firstItem.ord_service_title ||
                  "Healthcare Service"
                : s.ord_service_title || "Healthcare Service";

              const subtotalVal = parseFloat(s.subtotal || s.ord_subtotal || s.total_amount || s.ord_total_amount || 0);
              const gstVal = parseFloat(s.gst || s.ord_gst || 0);
              const grandTotalVal = parseFloat(s.total_amount || s.ord_total_amount || 0);
              const productTotalVal = subtotalVal > 0 ? subtotalVal : (grandTotalVal - gstVal > 0 ? grandTotalVal - gstVal : grandTotalVal);

              return {
                order_id: s.order_id || s.ord_id,
                order_no: s.order_number || s.ord_number,
                order_created: s.created || s.ord_created || s.created_at,
                order_grand_total: grandTotalVal,
                order_product_total: productTotalVal,
                order_gst_total: gstVal,
                order_tax_total: gstVal,
                order_delivery_charge: parseFloat(s.delivery_charge || s.ord_delivery_charge || 0),
                order_payment_method:
                  s.payment_status || s.ord_payment_status || "COD",
                order_payment_status:
                  s.payment_status || s.ord_payment_status || "Pending",
                order_status: s.order_status || s.ord_status || "Pending",
                order_address_id: s.ord_address_id || (s.address ? s.address.id : null),
                items:
                  s.items && s.items.length > 0
                    ? s.items.map((it) => {
                        const unitPrice = parseFloat(it.sale_price || it.price || it.ord_sale_price || it.ord_price || 0);
                        const qty = parseInt(it.qty || it.ord_qty || it.quantity || 1, 10);
                        const itemTotal = parseFloat(it.total_amount || it.subtotal || it.ord_total_amount || it.ord_subtotal || (unitPrice * qty));
                        return {
                          item_id: it.detail_id || it.ord_detail_id || Math.random(),
                          product_name:
                            it.service?.title ||
                            it.package?.title ||
                            it.ord_service_title ||
                            serviceTitle,
                          item_unit_price: unitPrice > 0 ? unitPrice : (itemTotal > 0 ? itemTotal / qty : 0),
                          item_qty: qty,
                          item_total_price: itemTotal,
                          sale_price: unitPrice,
                          quantity: qty,
                          product_image: null,
                        };
                      })
                    : [
                        {
                          item_id: 1,
                          product_name: serviceTitle,
                          item_unit_price: productTotalVal,
                          item_qty: 1,
                          item_total_price: productTotalVal,
                          sale_price: productTotalVal,
                          quantity: 1,
                          product_image: null,
                        },
                      ],
                address: s.address,
                patient: s.patient,
                _type: "service",
              };
            });
            allOrders = [...allOrders, ...formattedServices];
          }
        } catch (e) {}

        allOrders.sort(
          (a, b) =>
            new Date(b.order_created || 0) - new Date(a.order_created || 0),
        );
        setOrders(allOrders);
      } catch (err) {
        console.error("Error fetching orders:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [navigate]);

  const handleSelectOrder = (orderNo) => {
    setSearchParams({ id: orderNo });
  };

  const handleBackToList = () => {
    setSearchParams({});
  };

  if (loading) {
    return (
      <div className="outer-div-right">
        <div className="dashbord-right-section">
          <div className="content-dashborad-outer p-4">
            <ShimmerTable row={5} col={6} />
          </div>
        </div>
      </div>
    );
  }

  if (orders.length === 0) {
    return (
      <div className="outer-div-right">
        <div className="dashbord-right-section">
          <div className="content-dashborad-outer text-center py-5">
            <div className="outer-box-oc p-4 rounded bg-white shadow-sm">
              <h4 className="fw-bold mb-3">No Orders Found</h4>
              <p className="text-muted mb-4">
                You haven't placed any medical equipment or care orders yet.
              </p>
              <Link
                to="/product-on-rent"
                className="btn text-white px-4 py-2"
                style={{ backgroundColor: "#13baac", borderColor: "#13baac" }}
              >
                Browse Equipment on Rent
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Find the selected order if an ID parameter is present
  const selectedOrder = selectedOrderId
    ? orders.find(
        (o) =>
          String(o.order_no).toLowerCase() ===
            String(selectedOrderId).toLowerCase() ||
          String(o.order_id) === String(selectedOrderId),
      )
    : null;

  // Render Single Order Details if an order is selected
  if (selectedOrder) {
    const createdDate = selectedOrder.order_created
      ? new Date(selectedOrder.order_created).toLocaleDateString("en-IN", {
          day: "2-digit",
          month: "short",
          year: "numeric",
        })
      : "";

    return (
      <div className="outer-div-right">
        <div className="dashbord-right-section">
          <div className="content-dashborad-outer">
            <div className="mb-4">
              <button
                className="btn d-inline-flex align-items-center gap-2"
                onClick={handleBackToList}
                style={{
                  backgroundColor: "#ffffff",
                  color: "#13baac",
                  border: "1.5px solid #13baac",
                  fontWeight: "600",
                  padding: "8px 18px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.05)",
                }}
              >
                <ArrowBackIcon fontSize="small" /> Back to Orders List
              </button>
            </div>

            <div className="outer-box-oc mb-4" key={selectedOrder.order_id}>
              <div className="row">
                <div className="col-lg-7 col-12">
                  <div className="sr-sec">
                    <div className="box-top d-flex justify-content-between align-items-center">
                      <div className="sr-number">
                        <h4>ORDER #{selectedOrder.order_no}</h4>
                      </div>
                      <div className="sr-date">
                        <p>Date: {createdDate}</p>
                      </div>
                    </div>

                    {selectedOrder.items &&
                      selectedOrder.items.map((item) => (
                        <div className="loxer-sr" key={item.item_id}>
                          <div className="content-prices">
                            <div className="img-sr">
                              <img
                                src={item.product_image || ordersdetail}
                                alt={item.product_name}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.src = ordersdetail;
                                }}
                              />
                            </div>
                            <div className="text-sr-prices">
                              <div className="text-sr">
                                <h5>{item.product_name}</h5>
                                <div className="product-info">
                                  {item.attribute_value && (
                                    <p>
                                      Duration / Plan: {item.attribute_value}
                                    </p>
                                  )}
                                  <p>
                                    Unit Price: ₹
                                    {parseFloat(
                                      item.item_unit_price || 0,
                                    ).toLocaleString("en-IN")}
                                  </p>
                                </div>
                                <p className="qty">Qty : {item.item_qty}</p>
                              </div>
                              <div className="sr-prices">
                                <p>
                                  ₹
                                  {parseFloat(
                                    item.item_total_price || 0,
                                  ).toLocaleString("en-IN")}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                </div>

                <div className="col-lg-5 col-12">
                  <div className="cst-info">
                    <div className="cst-header box-top">
                      <h5>Customer Information</h5>
                    </div>
                    <div className="detail-cst">
                      <div className="icon-info">
                        <PersonOutlineOutlinedIcon />
                        <p>
                          {user
                            ? `${user.user_first_name} ${user.user_last_name}`
                            : "Customer"}
                        </p>
                      </div>
                      <div className="icon-info">
                        <EmailOutlinedIcon />
                        <p>{user ? user.user_email : "-"}</p>
                      </div>
                      <div className="icon-info">
                        <LocalPhoneOutlinedIcon />
                        <p>{user ? user.user_mobile : "-"}</p>
                      </div>
                      <div className="icon-info">
                        <FmdGoodOutlinedIcon />
                        <p>{renderAddress(selectedOrder)}</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-7 col-12">
                  <div className="payment-order">
                    <div className="box-top d-flex justify-content-between align-items-center">
                      <div className="sr-number">
                        <h4>Payment Summary</h4>
                      </div>
                      <div className="sr-date pyment-invoice">
                        <span className="badge bg-info text-dark me-2">
                          {selectedOrder.order_payment_method || "COD"}
                        </span>
                        <span
                          className={`badge ${
                            selectedOrder.order_payment_status ===
                              "Completed" ||
                            selectedOrder.order_payment_status === "Paid"
                              ? "bg-success"
                              : "bg-warning text-dark"
                          }`}
                        >
                          {selectedOrder.order_payment_status || "Pending"}
                        </span>
                      </div>
                    </div>
                    <div className="pymt-box">
                      <div className="nme-price">
                        <p className="pmt-box-text">Product Total</p>
                        <p className="pmt-box-price">
                          ₹
                          {parseFloat(
                            selectedOrder.order_product_total || 0,
                          ).toLocaleString("en-IN")}
                        </p>
                      </div>
                      {parseFloat(selectedOrder.order_security_total || 0) >
                        0 && (
                        <div className="nme-price">
                          <p className="pmt-box-text">Security Deposit</p>
                          <p className="pmt-box-price">
                            ₹
                            {parseFloat(
                              selectedOrder.order_security_total,
                            ).toLocaleString("en-IN")}
                          </p>
                        </div>
                      )}
                      <div className="nme-price">
                        <p className="pmt-box-text">GST Tax (5%)</p>
                        <p className="pmt-box-price">
                          ₹
                          {parseFloat(
                            selectedOrder.order_gst_total || 0,
                          ).toLocaleString("en-IN")}
                        </p>
                      </div>
                      <div className="nme-price total-price">
                        <h5 className="total-t">GRAND TOTAL</h5>
                        <p className="total-pricee">
                          ₹
                          {parseFloat(
                            selectedOrder.order_grand_total || 0,
                          ).toLocaleString("en-IN")}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-5 col-12">
                  <div className="billing-add-box">
                    <div className="box-top">
                      <div className="sr-number">
                        <h4>Order Status</h4>
                      </div>
                    </div>
                    <div className="billing-text p-3">
                      <p className="mb-1">
                        Current Status:{" "}
                        <strong className="text-success">
                          {selectedOrder.order_status || "Pending"}
                        </strong>
                      </p>
                      {selectedOrder.order_notes && (
                        <p className="small text-muted mb-0">
                          Notes: {selectedOrder.order_notes}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Render Table View (Default Orders List)
  return (
    <div className="outer-div-right">
      <div className="dashbord-right-section">
        <div className="content-dashborad-outer">
          <div className="order-tabs">
            <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link active"
                  id="pills-home-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-home"
                  type="button"
                  role="tab"
                  aria-controls="pills-home"
                  aria-selected="true"
                >
                  Caregiver
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="pills-profile-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-profile"
                  type="button"
                  role="tab"
                  aria-controls="pills-profile"
                  aria-selected="false"
                >
                  Products On Rent
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="pills-contact-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-contact"
                  type="button"
                  role="tab"
                  aria-controls="pills-contact"
                  aria-selected="false"
                >
                  Doctor Consultant
                </button>
              </li>
              <li class="nav-item" role="presentation">
                <button
                  class="nav-link"
                  id="pills-icu-tab"
                  data-bs-toggle="pill"
                  data-bs-target="#pills-icu"
                  type="button"
                  role="tab"
                  aria-controls="pills-icu"
                  aria-selected="false"
                >
                  ICU Home
                </button>
              </li>
            </ul>
            <div className="tab-content" id="pills-tabContent">
              <div
                className="tab-pane fade show active"
                id="pills-home"
                role="tabpanel"
                aria-labelledby="pills-home-tab"
                tabIndex="0"
              >
                <div className="table-dashbord table-responsive">
                  {orders.filter((o) => o._type === "service").length === 0 ? (
                    <div className="text-center py-4 text-muted">No service bookings found.</div>
                  ) : (
                    <table>
                      <thead>
                        <tr>
                          <th>Booking No</th>
                          <th>Service</th>
                          <th>Date</th>
                          <th>Amount</th>
                          <th>Payment</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orders
                          .filter((o) => o._type === "service")
                          .map((order) => {
                            const firstItem = order.items && order.items.length > 0 ? order.items[0] : null;
                            const itemName = firstItem ? firstItem.product_name : "Healthcare Service";
                            const extraItems = order.items && order.items.length > 1 ? ` (+${order.items.length - 1} more)` : "";
                            const createdDate = order.order_created
                              ? new Date(order.order_created).toLocaleDateString("en-IN", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                })
                              : "-";

                            return (
                              <tr key={order.order_id}>
                                <td>
                                  <button
                                    className="btn btn-link p-0 fw-bold"
                                    style={{ color: "#13baac", textDecoration: "none", cursor: "pointer" }}
                                    onClick={() => handleSelectOrder(order.order_no)}
                                  >
                                    {order.order_no}
                                  </button>
                                </td>
                                <td>{itemName}{extraItems}</td>
                                <td>{createdDate}</td>
                                <td>₹{parseFloat(order.order_grand_total || 0).toLocaleString("en-IN")}</td>
                                <td>{order.order_payment_method || "COD"}</td>
                                <td>
                                  <span className={`status ${(order.order_status || "Pending").toLowerCase()}`}>
                                    {order.order_status || "Pending"}
                                  </span>
                                </td>
                                <td>
                                  <button
                                    className="btn btn-sm d-inline-flex align-items-center gap-1"
                                    onClick={() => handleSelectOrder(order.order_no)}
                                    style={{
                                      backgroundColor: "#13baac",
                                      color: "#ffffff",
                                      borderRadius: "4px",
                                      fontWeight: "500",
                                      padding: "4px 10px",
                                      border: "none",
                                    }}
                                  >
                                    <VisibilityOutlinedIcon style={{ fontSize: "16px" }} /> View
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>

              <div
                className="tab-pane fade"
                id="pills-profile"
                role="tabpanel"
                aria-labelledby="pills-profile-tab"
                tabIndex="0"
              >
                <div className="table-dashbord table-responsive">
                  {orders.filter((o) => o._type === "product").length === 0 ? (
                    <div className="text-center py-4 text-muted">No product orders found.</div>
                  ) : (
                    <table>
                      <thead>
                        <tr>
                          <th>Order No</th>
                          <th>Product</th>
                          <th>Date</th>
                          <th>Amount</th>
                          <th>Payment</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {orders
                          .filter((o) => o._type === "product")
                          .map((order) => {
                            const firstItem = order.items && order.items.length > 0 ? order.items[0] : null;
                            const itemName = firstItem ? firstItem.product_name : "Medical Equipment";
                            const extraItems = order.items && order.items.length > 1 ? ` (+${order.items.length - 1} more)` : "";
                            const createdDate = order.order_created
                              ? new Date(order.order_created).toLocaleDateString("en-IN", {
                                  day: "2-digit",
                                  month: "short",
                                  year: "numeric",
                                })
                              : "-";

                            return (
                              <tr key={order.order_id}>
                                <td>
                                  <button
                                    className="btn btn-link p-0 fw-bold"
                                    style={{ color: "#13baac", textDecoration: "none", cursor: "pointer" }}
                                    onClick={() => handleSelectOrder(order.order_no)}
                                  >
                                    {order.order_no}
                                  </button>
                                </td>
                                <td>{itemName}{extraItems}</td>
                                <td>{createdDate}</td>
                                <td>₹{parseFloat(order.order_grand_total || 0).toLocaleString("en-IN")}</td>
                                <td>{order.order_payment_method || "COD"}</td>
                                <td>
                                  <span className={`status ${(order.order_status || "Pending").toLowerCase()}`}>
                                    {order.order_status || "Pending"}
                                  </span>
                                </td>
                                <td>
                                  <button
                                    className="btn btn-sm d-inline-flex align-items-center gap-1"
                                    onClick={() => handleSelectOrder(order.order_no)}
                                    style={{
                                      backgroundColor: "#13baac",
                                      color: "#ffffff",
                                      borderRadius: "4px",
                                      fontWeight: "500",
                                      padding: "4px 10px",
                                      border: "none",
                                    }}
                                  >
                                    <VisibilityOutlinedIcon style={{ fontSize: "16px" }} /> View
                                  </button>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>

              <div
                className="tab-pane fade"
                id="pills-contact"
                role="tabpanel"
                aria-labelledby="pills-contact-tab"
                tabIndex="0"
              >
                <div className="p-4 text-center text-muted">No Doctor Consultant bookings found.</div>
              </div>

              <div
                className="tab-pane fade"
                id="pills-icu"
                role="tabpanel"
                aria-labelledby="pills-icu-tab"
                tabIndex="0"
              >
                <div className="p-4 text-center text-muted">No ICU Home bookings found.</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
